import { Text, Button, Image, Flex } from '@chakra-ui/react';
import React from 'react';
import { useWatch } from 'react-hook-form';
import { upload } from '../../assets/new-images/icons';

const generateQuestionName = (question, surveyId) => {
 const { id_question } = question;

 const typePrefix =
  question.type === 'text'
   ? 'text'
   : question.type === 'multiple_choice'
   ? 'checkbox'
   : question.type === 'multi_choice'
   ? 'radio'
   : question.type === 'number'
   ? 'number'
   : question.type === 'money'
   ? 'money'
   : 'percentage';

 if (question.company?.id_company !== undefined && surveyId) {
  return `${surveyId}.${typePrefix}_question_${id_question}`;
 } else if (question?.id_theme !== undefined) {
  return `${typePrefix}_question_${id_question}_${question?.id_theme}`;
 } else {
  return `${typePrefix}_question_${id_question}`;
 }
};

export const AttachmentButton = React.memo(function ({
 surveyId,
 control,
 question,
 handleModal,
}) {
 const questionName = generateQuestionName(question, surveyId);
 const questionValue = useWatch({
  control,
  name: questionName,
 });
 const { request_files, request_images } = question;

 //  const hasFiles = questionValue?.files?.length > 0;
 //  const requiresAttachment = request_files || request_images;

 //  const isDisabled =
 //   requiresAttachment &&
 //   !hasFiles &&
 //   (!questionValue?.value ||
 //    (typeof questionValue.value === 'string' && questionValue.value.trim() === '') ||
 //    (Array.isArray(questionValue.value) && questionValue.value.length === 0));

 const isDisabled =
  (!request_files && !request_images) ||
  !questionValue ||
  questionValue?.value === undefined ||
  (typeof questionValue?.value === 'string' && questionValue?.value.trim() === '') ||
  (Array.isArray(questionValue?.value) && questionValue?.value?.length === 0);

 return (
  <Flex h='32px' align='center'>
   <Button
    color='blue.100'
    bg='white'
    h='32px'
    p={0}
    display='flex'
    alignItems='center'
    _hover={{
     bg: 'none',
    }}
    _active={{
     bg: 'none',
    }}
    isDisabled={isDisabled}
    onClick={() => handleModal(questionName, question)}
   >
    <Image src={upload} alt='Upload icon' mr='4px' />

    {questionValue?.files?.length > 0 ? (
     <Text
      as='span'
      fontSize='sm'
      lineHeight='16.44px'
      textDecor='underline'
      fontWeight={600}
     >
      Anexar/Visualizar Evidências
     </Text>
    ) : (
     <Text as='span' fontSize='sm' textDecor='underline' fontWeight={600}>
      Anexar Evidências
     </Text>
    )}
   </Button>
  </Flex>
 );
});
